import { BillState, RootState } from '@/types/store';
import { BillInput } from '@/types/graphql/schemaTypes';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';

// initial state
const state: BillState = {
  updateBillAttrs: {},
  billModalBaseProps: {},
  billToDelete: {},
  billToPublish: {}
};

const getters: GetterTree<BillState, RootState> = {};

// actions
const actions: ActionTree<BillState, RootState> = {};

// mutations
const mutations: MutationTree<BillState> = {
  setUpdateBillAttrs(billState: BillState, updateBillAttrs: BillInput): void {
    billState.updateBillAttrs = { ...updateBillAttrs };
  },

  setUpdateModalBaseProps(billState: BillState, billModalBaseProps: BillInput): void {
    billState.billModalBaseProps = { ...billModalBaseProps };
  },

  setBillToDelete(billState: BillState, bill: { id: string }): void {
    billState.billToDelete = { ...bill };
  },

  setBillToPublish(billState: BillState, billId: string): void {
    billState.billToPublish = { id: billId };
  }
};

export const bill: Module<BillState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
